"use client";

import { GalleryLightboxMobile } from "./gallery-lightbox-mobile";
import { GalleryLightboxDesktop } from "./gallery-lightbox-desktop";
import { useBodyScrollLock } from "../../../hooks/gallery-lightbox/use-body-scroll-lock";
import { useMediaQuery } from "../../../hooks/gallery-lightbox/use-media-query";

export type GalleryImageT = {
  src: string;
  alt?: string;
  title?: string;
};

export type GalleryLightboxPropsT = {
  images: GalleryImageT[];
  initialIndex?: number;
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Main gallery lightbox component with responsive behavior
 * Automatically switches between mobile and desktop variants based on screen size
 */
export function GalleryLightbox({
  images,
  initialIndex = 0,
  isOpen,
  onClose,
}: GalleryLightboxPropsT) {
  const isMobile = useMediaQuery("(max-width: 767px)");

  useBodyScrollLock(isOpen);

  if (!isOpen || images.length === 0) return null;

  const commonProps = {
    images,
    initialIndex,
    onClose,
  };

  return isMobile ? (
    <GalleryLightboxMobile {...commonProps} />
  ) : (
    <GalleryLightboxDesktop {...commonProps} />
  );
}
